<app-widget-app-image [imagePath]="image" [url]="url" [mode]="mode" (delete)="onDelete()"></app-widget-app-image>
